import React, { useState, useEffect } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Checkbox,
  TextField,
  Button,
  TablePagination,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { Add } from "@mui/icons-material";
import { useNotificationContext } from "../../common/NotificationContext";

const ItemTable = ({
  articles,
  setArticles,
  selectedArticles,
  setSelectedArticles,
  showFilter,
  setShowFilter,
  isSelectCheckBox,
  setIsSelectCheckBox,
  selectedRows: propSelectedRows,
  // setSelectedRows,
  orderType,
}) => {
  const { showNotification } = useNotificationContext();

  const [inputData, setInputData] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchInput, setSearchInput] = useState({});
  const [selectedRows, setSelectedRows] = useState(propSelectedRows);

  useEffect(() => {
    if (orderType === 2) {
      setSelectedRows([...articles]);
    }
  }, []);

  useEffect(() => {
    if (selectedArticles?.length > 0 && isSelectCheckBox === false) {
      const newArray = articles.map((item1) => {
        const item2 = selectedArticles.find(
          (item2) =>
            item2.articleCode + item2.poNumber ===
            item1.articleCode + item1.poNumber
        );

        return item2 ? { ...item1, ...item2 } : item1;
      });
      setArticles(newArray);
      setSelectedRows(selectedArticles);
      setIsSelectCheckBox(true);
    }
  }, [
    articles,
    isSelectCheckBox,
    selectedArticles,
    // selectedRows,
    setArticles,
    setIsSelectCheckBox,
    setSelectedRows,
  ]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleCheckboxChange = (event, article) => {
    const uniqueKey = article.articleCode + article.poNumber;
    if (event.target.checked) {
      setSelectedRows([...selectedRows, article]);
    } else {
      setSelectedRows(
        selectedRows.filter(
          (row) => row.articleCode + row.poNumber !== uniqueKey
        )
      );
    }
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedRows([...articles]);
    } else {
      setSelectedRows([]);
    }
  };

  const handleInputChange = (event, article) => {
    const { name, value } = event.target;
    const integerValue = value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
    const newValue = integerValue === "" ? "" : parseInt(integerValue, 10);

    // setInputData({
    //   ...inputData,
    //   [article.articleCode]: {
    //     ...inputData[article.articleCode],
    //     [name]: value,
    //   },
    // });
    const uniqueKey = article.articleCode + article.poNumber;
    setInputData((prevData) => ({
      ...prevData,
      [uniqueKey]: {
        ...prevData[uniqueKey],
        [name]: newValue, // Update the articleBoxQuantity or other fields
      },
    }));
  };

  const handleSearchInputChange = (event, columnName) => {
    setSearchInput({ ...searchInput, [columnName]: event.target.value });
  };

  const filterArticles = (articles) => {
    return articles.filter((article) => {
      for (const key in searchInput) {
        if (searchInput[key]) {
          if (
            !article[key]
              .toString()
              .toLowerCase()
              .includes(searchInput[key].toLowerCase())
          ) {
            return false;
          }
        }
      }
      return true;
    });
  };

  const handleSubmit = () => {
    const checkedRowsWithInputs = selectedRows.map((row) => {
      const uniqueKey = row.articleCode + row.poNumber; // Use row instead of article

      return {
        ...row,
        articleBoxQuantity:
          inputData[uniqueKey]?.articleBoxQuantity ?? row.articleBoxQuantity,
        articleQuantity:
          inputData[uniqueKey]?.articleQuantity ?? row.articleQuantity,
      };
    });

    const newSelectedArticles = [...checkedRowsWithInputs];

    // Set the state with the updated selections
    setSelectedArticles(newSelectedArticles);
    setSelectedRows(newSelectedArticles);
    if (newSelectedArticles.length > 0) {
      showNotification("Success", "Item added successfully", "success");
    }
  };

  const handleShowFilter = () => {
    showFilter === false ? setShowFilter(true) : setShowFilter(false);
  };

  return (
    <>
      <Paper>
        <TableContainer sx={{ mt: 1 }}>
          <Table>
            <TableHead>
              <TableRow
                className="tableHeader"
                size="small"
                variant="head"
                sx={{ pt: 1.5, pb: 1.5, fontSize: "13px" }}
              >
                <TableCell padding="checkbox">
                  <Checkbox
                    indeterminate={
                      selectedRows?.length > 0 &&
                      selectedRows?.length < articles.length
                    }
                    checked={
                      selectedRows?.length === articles?.length ||
                      orderType === 2
                    }
                    onChange={handleSelectAll}
                  />
                </TableCell>
                <TableCell>PO/ASN Number</TableCell>
                <TableCell>Article Code</TableCell>
                <TableCell>Article Name</TableCell>
                <TableCell>Article Quantity</TableCell>
                <TableCell>EAN Number</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {showFilter && (
                <TableRow className="tableHeader fallFromTop">
                  <TableCell></TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      onChange={(e) => handleSearchInputChange(e, "poNumber")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    {" "}
                    <TextField
                      size="small"
                      onChange={(e) =>
                        handleSearchInputChange(e, "articleCode")
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      onChange={(e) =>
                        handleSearchInputChange(e, "articleName")
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      type="number"
                      onChange={(e) =>
                        handleSearchInputChange(e, "articleQuantity")
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      size="small"
                      onChange={(e) => handleSearchInputChange(e, "eanNumber")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </TableCell>
                </TableRow>
              )}
              {filterArticles(articles)
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((article, index) => (
                  <TableRow key={index} className="fallFromTop">
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedRows.some(
                          (row) =>
                            row.articleCode + row.poNumber ===
                            article.articleCode + article.poNumber
                        )}
                        onChange={(event) =>
                          handleCheckboxChange(event, article)
                        }
                      />
                    </TableCell>
                    <TableCell>{article.poNumber}</TableCell>
                    <TableCell>{article.articleCode}</TableCell>
                    <TableCell>{article.articleName}</TableCell>
                    <TableCell>
                      <TextField
                        name="articleBoxQuantity"
                        size="small"
                        autoComplete="off"
                        value={
                          inputData[article.articleCode + article.poNumber]
                            ?.articleBoxQuantity ??
                          article.articleBoxQuantity ??
                          article.articleQuantity
                        }
                        onChange={(event) => handleInputChange(event, article)}
                      />
                    </TableCell>

                    <TableCell>{article.eanNumber}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={articles.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      <br></br>

      <Button
        variant="contained"
        startIcon={<Add />}
        onClick={handleSubmit}
        disabled={selectedRows.length === 0}
        sx={{ mr: 5 }}
      >
        Add Items
      </Button>
      <Button
        startIcon={showFilter ? <FilterAltOffIcon /> : <FilterAltIcon />}
        variant="outlined"
        onClick={handleShowFilter}
      >
        {showFilter ? "Hide Filter" : "Show Filter"}
      </Button>

      <br></br>
    </>
  );
};

export default ItemTable;
